import AuthRoute from './AuthRoute';
import Button from '@rezdy/components/Button';
import Field from '@rezdy/components/Form/Field';
import Grid from '@rezdy/components/Grid';
import { H4 } from '@rezdy/components/Heading';
import HR from '@rezdy/components/HR';
import Password from '@rezdy/components/Password';
import { RECAPTCHA_STORAGE_KEY } from '../constants/storage';
import React from 'react';
import SocialLogin from './SocialLogin';
import { TIdentityProvider } from '../services/auth';
import TextInput from '@rezdy/components/Form/FormElements/TextInput';
import TextStyle from '@rezdy/components/TextStyle';
import { getRecaptcha } from '../services/recaptcha';
import routes from '../constants/routes';
import routing from '../services/routing';
import socialAuthorize from '../actions/socialAuthorize';
import storage from '../services/storage';
import Link from '@rezdy/components/Link';
import { withTranslation } from 'react-i18next';

// TODO - unit tests...
export class SignIn extends AuthRoute {
    onHandleSocialLogin = async (provider: TIdentityProvider) => {
        try {
            // redirect uri needs to be custom ui
            await socialAuthorize(provider);
        } catch (error) {
            this.setState({
                isDirty: true,
                isLoading: false,
                message: error.message,
            });
        }
    };

    componentDidMount() {
        const useRecaptcha = storage.loadState(RECAPTCHA_STORAGE_KEY);
        if (useRecaptcha) {
            getRecaptcha().render();
        }
    }

    renderHeader = () => {
        const { context, i18n } = this.props;
        return (
            <TextStyle align="center">
                <H4>{i18n.t('header', { context })}</H4>
                <TextStyle as="p">{i18n.t('subHeader', { context })}</TextStyle>
            </TextStyle>
        );
    };

    renderBody = () => {
        const { i18n } = this.props;
        const { isDirty } = this.state;
        return (
            <Grid.Container rowGap="32px">
                <Field label={i18n.t('username')} name="username" isDirty={isDirty}>
                    <TextInput type="email" />
                </Field>
                <Field
                    label={i18n.t('password')}
                    name="password"
                    isDirty={isDirty}
                    action={
                        <Link href={routing.link(routes.FORGOT_PASSWORD)}>
                            {i18n.t('primaryAction', { context: 'forgotPasswordPrompt' })}
                        </Link>
                    }
                >
                    <Password />
                </Field>
            </Grid.Container>
        );
    };

    renderFormFooter = () => {
        const { isLoading } = this.state;
        const { context, i18n } = this.props;
        return (
            <>
                <Button
                    data-test-id={`primary-action-${context}`}
                    type="submit"
                    action="primary"
                    loading={isLoading}
                    width="100%"
                    tight
                >
                    {i18n.t('primaryAction', { context })}
                </Button>
                <HR>{i18n.t('subHeader', { context: 'signInSocial' })}</HR>
                <Grid.Container cols="repeat(auto-fit, minmax(220px, 1fr))" colGap rowGap>
                    <Grid.Cell>
                        <SocialLogin provider="Google" handleClick={this.onHandleSocialLogin} />
                    </Grid.Cell>
                </Grid.Container>
            </>
        );
    };

    onSecondaryClick = () => {
        routing.push(routes.SIGN_UP_SELECTION);
    };

    renderSecondaryAction = () => {
        return <></>;
    };
}

export default withTranslation()(SignIn);
